// extracted by mini-css-extract-plugin
export default {"wrapper__stats":"Home_wrapper__stats__X9kCz"};